import { IAdminUser } from "~/components/Admin/Settings/Users/interfaces/AdminUserInterface"
import { UserProps } from "../interfaces"
import { destroy, patch, post, get } from "./utils/requests"
import { UpdateAdminProps } from "~/components/Admin/Settings/Users/types/ApiUserTypes"

const fetchAdminUsers = (camp_id: string): Promise<{ users: IAdminUser[] }> => {
  return get(`/admin/admin_users?camp_id=${camp_id}`)
}

const sendResetPassword = async (id: string, campId: string): Promise<void> => {
  post(`/admin/admin_users/${id}/send_reset_password`, { camp_id: campId })
}

const updateAdminUser = (id: string, camp_id: string, data: UpdateAdminProps): Promise<UpdateAdminProps> =>
  patch(`/admin/admin_users/${id}`, { admin_user: data, camp_id })

const createAdminUser = (camp_id: string, data: UpdateAdminProps): Promise<UpdateAdminProps> =>
  post(`/admin/admin_users`, { admin_user: data, camp_id })

const resendInviteUser = (id: string, camp_id: string): Promise<UpdateAdminProps> =>
  post(`/admin/admin_users/${id}/invite`, { camp_id })

const deleteUser = (id: string, camp_id: string): Promise<UpdateAdminProps> =>
  destroy(`/admin/admin_users/${id}?camp_id=${camp_id}`)

const update = (id: string, data: Partial<UserProps>): Promise<UserProps> => patch(`/users/${id}`, { user: data })

const Users = {
  sendResetPassword,
  updateAdminUser,
  createAdminUser,
  resendInviteUser,
  deleteUser,
  fetchAdminUsers,
  update,
}

export default Users
